import { render, staticRenderFns } from "./AdminExamSettingsDatesGrid.vue?vue&type=template&id=19236e56"
import script from "./AdminExamSettingsDatesGrid.vue?vue&type=script&lang=js"
export * from "./AdminExamSettingsDatesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports